<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field  label="Search" placeholder="Search" class="px-1"
                     v-model="table_data.search"
                     clearable
                     flat dense
                     solo-inverted
                     hide-details
                     prepend-inner-icon="mdi-magnify"
                     @change="$router.replace({name: $route.name, query: {...$route.query, search: table_data.search}})"
      ></v-text-field>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card>
            <v-card-text>
              <date-field input-class="mx-2" flat dense solo-inverted label="From" v-model="date_from" clearable/>
              <date-field input-class="mx-2" flat dense solo-inverted label="Till" v-model="date_to" clearable/>

              <v-select label="Practice area" class="px-1"
                        :items="practice_areas"
                        v-model="table_data.practice_area"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
                        @change="$router.replace({name: $route.name, query: {...$route.query, practice_area: table_data.practice_area}})"
              />
              <v-select label="Session type" class="px-1"
                        :items="session_types"
                        v-model="table_data.session_type"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
                        @change="$router.replace({name: $route.name, query: {...$route.query, session_type: table_data.session_type}})"
              />


            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" class="pl-md-0">

          <v-card>
            <v-data-table :headers="table_data.headers"
                          :items="table_data_items"
                          :search="table_data.search">
              <template v-slot:item.start="{ value }">
                {{ $moment(value).format('DD/MM/YYYY hh:mm A') }}
              </template>
              <template v-slot:item.deadline="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY hh:mm A') : null }}
              </template>
              <template v-slot:item.return_marked="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY hh:mm A') : null }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" :to="{name: 'Session', params: {session_id: item.id}}">open</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    date_from: null,
    date_to: null,
    table_data: {
      headers: [
        { text: 'Tutor', value: 'tutor.nickname' },
        { text: 'Name', value: 'short_name' },
        { text: 'Session type', value: 'session_type.name' },
        { text: 'Practice area', value: 'practice_area.name' },
        { text: 'Start', value: 'start' },
        { text: 'Deadline', value: 'deadline' },
        { text: 'Ready', value: 'ready' },
        { text: 'Return marked', value: 'return_marked' },
        { text: 'Marked', value: 'marked' },
        { text: 'Mark', value: 'final_mark' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',

      practice_area: null,
      session_type: null,
    },
    api_errors: [],
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    table_data_items: function () {
      let items = []

      items.push(...this.table_data.items)

      if(this.table_data.practice_area) {
        items = items.filter(item => item.practice_area_id === this.table_data.practice_area)
      }
      if(this.table_data.session_type) {
        items = items.filter(item => item.session_type_id === this.table_data.session_type)
      }

      return items
    },
  },
  watch: {
    'date_from': function() {
      this.loadData()
    },
    'date_to': function() {
      this.loadData()
    },
  },
  created() {
    // this.date_from = this.$currentTime().subtract(1, "year").format('YYYY-MM-DD')
    // this.date_to = this.$currentTime().add(3, 'months').format('YYYY-MM-DD')
    if(this.$route.query.search) this.table_data.search = this.$route.query.search
    if(this.$route.query.practice_area) this.table_data.practice_area = parseInt(this.$route.query.practice_area)
    if(this.$route.query.session_type) this.table_data.session_type = parseInt(this.$route.query.session_type)

    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/students/${this.$route.params.student_id}/sessions`, {
        params:{date_from: this.date_from, date_to: this.date_to}
      })
          .then(({data}) => data.data)
    },
  }
}
</script>